<template>
  <div class="qa-question-detail-teacher">
    <div class="no-list">
      <span>该问题暂无回答,</span>
      <span v-if="teacherList.length">或许你可以寻求下方老师的帮助</span>
    </div>
    <div class="teacher-list" v-if="teacherList.length">
      <div
        :class="{
          'item-for-zx': true,
          'consult-common-list-item-v5': true
        }"
        @click="toTeacher(item)"
        v-for="item in teacherList"
        :key="item.user_id"
      >
        <div
          class="consult-common-list-item-v5-avatar"
          :style="{
            'background-image': 'url(' + imgZip(item.avatar, 140) + ')'
          }"
        >
          <img
            src="~images/qa/questions/icon-care.png"
            alt=""
            class="icon-consult-care"
          />
        </div>
        <div class="consult-common-list-item-v5-content">
          <div class="consult-common-list-item-v5-info">
            <div class="consult-common-list-item-v5-name">{{ item.name }}</div>
            <img
              v-if="item.level_icon"
              class="icon-consult-level"
              :src="item.level_icon"
            />
            <button class="consult-common-list-item-v5-btn">
              去咨询<img
                src="~images/qa/questions/icon-right3.png"
                alt=""
                class="icon-right3"
              />
            </button>
          </div>

          <p class="consult-common-list-item-v5-honer">{{ item.honor }}</p>
          <div
            class="consult-common-list-item-v5-tags"
            v-if="item.tags && item.tags.length"
          >
            擅长领域：
            <span
              v-for="tag in item.tags"
              :key="tag"
              class="consult-common-list-item-v5-tags-item"
            >
              {{ tag }}
            </span>
          </div>

          <div class="consult-common-list-item-v5-num-address">
            <span class="consult-common-list-item-v5-zx-num">
              <span class="num-bold">{{
                +item.zx_num < 50 ? '近50' : item.zx_num
              }}</span
              >人次咨询
            </span>
            <i class="consult-common-list-item-v5-cur">·</i>
            <span class="consult-common-list-item-v5-experience-year">
              从业<span class="num-bold">{{ item.experience_year }}</span
              >年
            </span>
            <span class="consult-common-list-item-v5-address">
              <icon name="dingwei1" class="icon-address" />{{ item.city }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { imgZip } from 'app/web/filters/ossImg.js'
import qs from 'qs'

export default {
  inject: ['questionTags'],
  data() {
    return {
      item: {}
    }
  },
  computed: {
    teacherList() {
      return this.$store.state.qaQuestionDetail.teacherList || []
    }
  },
  methods: {
    toTeacher(item) {
      // 神策埋点
      this.$trackEvent('qa_question_details_psychologist', {
        ...this.questionTags,
        qa_id: this.$route.params.id, //问题ID
        to_user_status: ['咨询师']
      })

      const queryStr = qs.stringify({
        node: 1,
        channel_flag: 'Platform_content_QA'
      })
      this.routerPushWithoutNav(
        `https://m.xinli001.com/homepage/${item.user_id}?${queryStr}`
      )
    },
    imgZip
  }
}
</script>

<style lang="scss">
.qa-question-detail-teacher {
  background: #ffffff;

  .line-position {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .no-list {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 52px 0 50px;
    font-size: 30px;
    font-weight: 400;
    color: #bcc2cf;
    line-height: 52px;
    text-align: center;
    &::before {
      content: '-';
      @extend .line-position;
      left: 100px;
    }
    &::after {
      content: '-';
      @extend .line-position;
      right: 100px;
    }
  }
  .teacher-list {
    padding: 0 32px;
  }
  .consult-common-list-item-v5 {
    .num-bold {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #21252d;
      font-style: normal;
    }
    padding: 30px 0 30px 0;
    display: flex;
    position: relative;

    &:not(.last):before {
      position: absolute;
      left: 106 + 30 + 20px;
      right: 20px;
      bottom: 0;
      border-bottom: 1px solid #f3f4f5;
      content: '';
      transform: scaleY(0.5);
    }

    &-avatar {
      flex-shrink: 0;
      margin-right: 20px;
      display: block;
      background-size: cover;
      background-position: center;
      position: relative;
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 20px;
      width: 140px;
      height: 140px;
      .icon-consult-care {
        width: 140px;
        height: 30px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -2px;
      }
    }

    &-content {
      align-self: center;
      flex: 1;
      min-width: 0;
      & > *:not(:nth-last-child(1)) {
        margin-bottom: 18px;
      }
    }

    &-info {
      display: flex;
      color: #21252d;
      align-items: center;
    }

    &-name {
      font-size: 32px;
      line-height: 35px; // hack: iOS下，如果出现省略号，会显示出来一小部分第二行
      height: 34px;
      margin-right: 10px;
      font-weight: bold;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      max-width: 160px;
      color: #21252d;
      display: inline-block;
    }
    .icon-consult-level {
      width: 82px;
      height: 30px;
      border-radius: 8px;
    }
    &-btn {
      display: flex;
      align-items: center;
      font-size: 22px;
      color: #6982fa;
      line-height: 22px;
      background: transparent;
      margin-left: auto;
      .icon-right3 {
        width: 16px;
        height: 16px;
        margin-left: 3px;
      }
    }

    &-zx-num,
    &-cur,
    &-experience-year {
      font-size: 22px;
      line-height: 24px;
      padding-right: 10px;
      white-space: nowrap;
    }

    &-honer {
      font-size: 24px;
      font-weight: 400;
      color: #434c5c;
      line-height: 26px;
      word-break: break-all;
      @include overLine(1);
    }

    &-tags {
      font-size: 24px;
      color: #434c5c;
      line-height: 24px;
      @include overLine(1);
    }
    &-tags-item {
      &:not(:nth-child(1)) {
        &::before {
          content: '/';
        }
      }
    }

    &-num-address {
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #434c5c;
      line-height: 24px;
    }
    &-address {
      font-size: 22px;
      color: #9da3ac;
      line-height: 22px;
      flex-shrink: 0;
      margin-left: auto;

      .icon-address {
        font-size: 20px;
        line-height: 22px;
        margin-right: 10px;
      }
    }
  }
}
</style>
